// Generated by BUCKLESCRIPT VERSION 5.0.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/src/Css.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Store = require("../store.bs.js");
var React = require("react");

var container = Css.merge(/* :: */[
      Css.style(/* :: */[
            Css.borderWidth(Css.zero),
            /* :: */[
              Css.borderRadius(Css.zero),
              /* :: */[
                Css.color(Css.hex("fafafa")),
                /* :: */[
                  Css.cursor(/* pointer */-786317123),
                  /* :: */[
                    Css.display(Css.inlineBlock),
                    /* :: */[
                      Css.flexBasis(Css.pct(25)),
                      /* :: */[
                        Css.fontSize(Css.em(1.5)),
                        /* :: */[
                          Css.lineHeight(/* `abs */[
                                4845682,
                                2
                              ]),
                          /* :: */[
                            Css.outlineStyle(Css.none),
                            /* :: */[
                              Css.transitions(/* :: */[
                                    Css.transition(300, undefined, Css.easeOut, "background-color"),
                                    /* :: */[
                                      Css.transition(300, undefined, Css.easeOut, "color"),
                                      /* [] */0
                                    ]
                                  ]),
                              /* :: */[
                                Css.hover(/* :: */[
                                      Css.backgroundColor(Css.hex("fafafa")),
                                      /* [] */0
                                    ]),
                                /* [] */0
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]),
      /* [] */0
    ]);

function variant(colorCode) {
  return Css.style(/* :: */[
              Css.backgroundColor(Css.hex(colorCode)),
              /* :: */[
                Css.hover(/* :: */[
                      Css.color(Css.hex(colorCode)),
                      /* [] */0
                    ]),
                /* [] */0
              ]
            ]);
}

var blue = variant("6d71ff");

var green = variant("3bf3a9");

var orange = variant("ff8754");

var Styles = /* module */[
  /* container */container,
  /* variant */variant,
  /* blue */blue,
  /* green */green,
  /* orange */orange
];

function Button(Props) {
  var action = Props.action;
  var text = Props.text;
  var color;
  if (typeof action === "number") {
    switch (action) {
      case 4 : 
          color = blue;
          break;
      case 0 : 
      case 2 : 
      case 3 : 
      case 5 : 
      case 6 : 
          color = orange;
          break;
      case 1 : 
      case 7 : 
      case 8 : 
          color = green;
          break;
      
    }
  } else {
    color = blue;
  }
  var addOperation = Store.useAddOperation(/* () */0);
  var onClick = React.useCallback((function (param) {
          return Curry._1(addOperation, action);
        }));
  return React.createElement("button", {
              className: Css.merge(/* :: */[
                    container,
                    /* :: */[
                      color,
                      /* [] */0
                    ]
                  ]),
              onClick: onClick
            }, text);
}

var make = Button;

exports.Styles = Styles;
exports.make = make;
/* container Not a pure module */
